import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <a href="/" className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c496e7b7b0d35cec41af6fd81216106e.png"
            alt="IGM Facility Service Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Leistungen", id: "leistungen" },
            { label: "Vorteile", id: "vorteile" },
            { label: "Referenzen", id: "referenzen" },
            { label: "Kontakt", id: "kontakt" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-700 hover:text-black" : "text-white/90 hover:text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
          <a
            href="tel:+492102739807"
            className="flex items-center gap-2 bg-black text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            02102 7398070
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü öffnen"
        >
          <i className={`text-2xl ${scrolled ? "text-black" : "text-white"} ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-5 py-5 flex flex-col gap-1">
          {[
            { label: "Leistungen", id: "leistungen" },
            { label: "Vorteile", id: "vorteile" },
            { label: "Referenzen", id: "referenzen" },
            { label: "Kontakt", id: "kontakt" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-base font-medium text-gray-700 hover:text-black text-left cursor-pointer py-3 border-b border-gray-100 last:border-0"
            >
              {item.label}
            </button>
          ))}
          <a
            href="tel:+492102739807"
            className="mt-3 bg-black text-white text-sm font-semibold px-5 py-3.5 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line"></i>
            02102 7398070
          </a>
        </div>
      )}
    </nav>
  );
}
